export default function reducer(oldProps, newProps) {
    return ({
        ...oldProps,
        ...newProps,
    })
}
